import React from 'react';

const HealthDeclarationSummaryHeader: React.FC = ({}) => {
  return (
    <div className='pt-8 flex flex-col justify-between items-start text-navy-primary'>
      <div className='font-semibold text-2xl font-Outfit'>Hälsodeklarationen är klar</div>
      <div className='text-navy-primary font-Outfit'>Vänligen ge surfplattan till tatueraren</div>
      <div className='h-[1px] w-full bg-navy-primary mt-4'></div>
    </div>
  );
};

export default HealthDeclarationSummaryHeader;
